const WHITE_COLOR = '#ffffff';
const BLACK_COLOR = '#202124';

const TRANSPARENT_WHITE_COLOR = 'rgba(255,255,255,0)';

const FEATURE_COLORS = ['#bbe1ddd9', '#ffc8c3d9', '#c8e3f8d9', '#ffe1bed9'];

export { FEATURE_COLORS, WHITE_COLOR, BLACK_COLOR, TRANSPARENT_WHITE_COLOR };
